<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label">
  <div app-theme-option-content>
    <app-theme-option-font-style [fontStyle]="themeOptions.options().tooltips.titleFontStyle" (sendFontStyle)="receiveValue($event)"></app-theme-option-font-style>
  </div>
</app-theme-option>